export default __webpack_public_path__ + "static/media/Grace.2d91fbe2.jpg";